import { z } from "zod";

/**
 * Message field for contact forms
 */
export const messageField = z
  .string()
  .min(1, "Message is required")
  .max(2000, "Message must be 2,000 characters or less");

/**
 * Optional message field
 */
export const optionalMessageField = z
  .string()
  .max(2000, "Message must be 2,000 characters or less")
  .optional();

/**
 * Organization name field
 */
export const organizationField = z
  .string()
  .min(1, "Organization is required")
  .max(255, "Organization must be 255 characters or less");

/**
 * Organizations field (for alumni affiliations)
 */
export const organizationsField = z
  .string()
  .min(1, "Organizations is required")
  .max(255, "Organizations must be 255 characters or less");

/**
 * Website field (optional)
 * Empty strings are valid (no URL validation), non-empty strings must be valid URLs
 */
export const websiteField = z
  .string()
  .max(255, "Website must be 255 characters or less")
  .refine((val) => val === "" || z.string().url().safeParse(val).success, {
    message: "Please enter a valid URL",
  })
  .optional();

/**
 * Bio/description field (optional)
 */
export const bioField = z
  .string()
  .max(2000, "Bio must be 2,000 characters or less")
  .nullable()
  .optional()
  .transform((val) => val ?? undefined);

/**
 * Pronouns field (optional)
 */
export const pronounsField = z
  .string()
  .max(50, "Pronouns must be 50 characters or less")
  .nullable()
  .optional()
  .transform((val) => val ?? undefined);

/**
 * Timezone field (array of strings, at least one required)
 */
export const timezoneField = z.array(z.string()).min(1, "Timezone is required");

/**
 * Boolean field for email notifications
 */
export const emailNotificationsField = z.boolean().optional();

/**
 * Boolean field for text notifications
 */
export const textNotificationsField = z.boolean().optional();
